import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-base-unsubscribe',
  templateUrl: './base-unsubscribe.component.html',
  standalone: true,
})
export class BaseUnsubscribeComponent implements OnDestroy {
  readonly unsubscribe$ = new Subject<void>();

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
